<template>
    <div>
        <title>{{ $t("items.text_1") }} - DOFFERO®</title>
        <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous"
        />
        <div class="cont">
            <div v-if="createEdit == 0">
                <h1>{{ $t("items.text_2") }}</h1>
                <h3>{{ $t("items.text_3") }}</h3>
                <div class="search_create_btns filter1">
                    <div
                        class="page-header-title d-flex align-items-center position-relative"
                    >
                        <input
                            v-model="search"
                            class="filter_input"
                            type="text"
                            :placeholder="$t('items.text_39')"
                        />
                        <svg
                            v-if="!loading"
                            class="filter_svg"
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                        >
                            <mask id="path-1-inside-1" fill="white">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M11.4947 4.42476C13.4129 6.41116 13.3577 9.5765 11.3713 11.4947C9.38488 13.413 6.21953 13.3577 4.30129 11.3713C2.38304 9.38494 2.43829 6.2196 4.4247 4.30135C6.4111 2.38311 9.57644 2.43836 11.4947 4.42476ZM13.5589 12.0175C15.5266 9.32026 15.3321 5.51944 12.9334 3.03544C10.2478 0.254479 5.81634 0.177127 3.03538 2.86267C0.254416 5.54822 0.177064 9.9797 2.86261 12.7607C5.31231 15.2974 9.21474 15.5845 11.992 13.5771L12.9187 14.5367L13.4306 15.0667L14.8199 16.5054L14.9713 16.3592L16.2586 15.1161L16.41 14.9699L15.0207 13.5312L14.5088 13.0011L13.5589 12.0175Z"
                                />
                            </mask>
                            <path
                                d="M13.5589 12.0175L11.9432 10.8388L10.9522 12.1972L12.1203 13.4068L13.5589 12.0175ZM11.992 13.5771L13.4307 12.1878L12.226 10.9402L10.8204 11.9562L11.992 13.5771ZM12.9187 14.5367L14.3574 13.1474L12.9187 14.5367ZM13.4306 15.0667L11.9919 16.4561L13.4306 15.0667ZM14.8199 16.5054L13.3812 17.8947L14.7705 19.3334L16.2092 17.9441L14.8199 16.5054ZM14.9713 16.3592L13.582 14.9205L14.9713 16.3592ZM16.2586 15.1161L17.6479 16.5548L16.2586 15.1161ZM16.41 14.9699L17.7993 16.4085L19.238 15.0192L17.8487 13.5805L16.41 14.9699ZM15.0207 13.5312L13.582 14.9205L15.0207 13.5312ZM14.5088 13.0011L15.9475 11.6118L14.5088 13.0011ZM12.7606 12.9334C15.5416 10.2479 15.6189 5.8164 12.9334 3.03544L10.056 5.81408C11.207 7.00592 11.1738 8.90512 9.98196 10.0561L12.7606 12.9334ZM2.86261 12.7607C5.54815 15.5416 9.97963 15.619 12.7606 12.9334L9.98196 10.0561C8.79012 11.207 6.89092 11.1739 5.73997 9.98203L2.86261 12.7607ZM3.03538 2.86267C0.254416 5.54822 0.177064 9.9797 2.86261 12.7607L5.73997 9.98203C4.58902 8.79018 4.62217 6.89098 5.81401 5.74003L3.03538 2.86267ZM12.9334 3.03544C10.2478 0.254479 5.81634 0.177127 3.03538 2.86267L5.81401 5.74003C7.00585 4.58908 8.90506 4.62223 10.056 5.81408L12.9334 3.03544ZM15.1747 13.1962C17.7054 9.72716 17.4576 4.84131 14.372 1.64612L11.4947 4.42476C13.2067 6.19756 13.3478 8.91336 11.9432 10.8388L15.1747 13.1962ZM14.372 1.64612C10.9192 -1.9294 5.22159 -2.02885 1.64606 1.42399L4.4247 4.30135C6.4111 2.38311 9.57644 2.43836 11.4947 4.42476L14.372 1.64612ZM1.64606 1.42399C-1.92946 4.87684 -2.02891 10.5745 1.42393 14.15L4.30129 11.3713C2.38304 9.38494 2.43829 6.2196 4.4247 4.30135L1.64606 1.42399ZM1.42393 14.15C4.57473 17.4127 9.59131 17.7801 13.1636 15.198L10.8204 11.9562C8.83818 13.389 6.04988 13.1821 4.30129 11.3713L1.42393 14.15ZM10.5533 14.9664L11.48 15.926L14.3574 13.1474L13.4307 12.1878L10.5533 14.9664ZM11.48 15.926L11.9919 16.4561L14.8693 13.6774L14.3574 13.1474L11.48 15.926ZM11.9919 16.4561L13.3812 17.8947L16.2586 15.1161L14.8693 13.6774L11.9919 16.4561ZM16.2092 17.9441L16.3606 17.7979L13.582 14.9205L13.4306 15.0667L16.2092 17.9441ZM16.3606 17.7979L17.6479 16.5548L14.8693 13.6774L13.582 14.9205L16.3606 17.7979ZM17.6479 16.5548L17.7993 16.4085L15.0207 13.5312L14.8693 13.6774L17.6479 16.5548ZM17.8487 13.5805L16.4594 12.1419L13.582 14.9205L14.9713 16.3592L17.8487 13.5805ZM16.4594 12.1419L15.9475 11.6118L13.0702 14.3905L13.582 14.9205L16.4594 12.1419ZM15.9475 11.6118L14.9976 10.6282L12.1203 13.4068L13.0702 14.3905L15.9475 11.6118Z"
                                fill="#DDE3E8"
                                mask="url(#path-1-inside-1)"
                            />
                        </svg>
                        <svg
                            v-else
                            class="filter_svg rotating"
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <defs>
                                <linearGradient
                                    id="circleGradient"
                                    x1="0%"
                                    y1="0%"
                                    x2="100%"
                                    y2="100%"
                                >
                                    <stop
                                        offset="0%"
                                        style="
                                            stop-color: #dde3e8;
                                            stop-opacity: 1;
                                        "
                                    />
                                    <stop
                                        offset="100%"
                                        style="
                                            stop-color: #adb3b7;
                                            stop-opacity: 1;
                                        "
                                    />
                                </linearGradient>
                            </defs>
                            <circle
                                cx="8.5"
                                cy="8.5"
                                r="8"
                                fill="url(#circleGradient)"
                            />
                            <circle cx="8.5" cy="8.5" r="6" fill="white" />
                        </svg>
                    </div>
                    <a class="create_item" @click="createItem">
                        <svg class="mr-2" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle;"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                        {{ $t("items.text_4") }}
                    </a>
                </div>
                <div class="rich-list">
                    <div
                        v-for="item in filteredItems"
                        :key="item.id"
                        class="rich-item"
                    >
                        <!-- Left: identity -->
                        <div class="ri-main">
                            <div class="ri-title-row">
                                <span class="ri-title" :title="item.interny_nazov">{{ item.interny_nazov }}</span>
                                <span v-if="item.id_sku" class="ri-sku" :title="item.id_sku">{{ item.id_sku }}</span>
                                <span class="ri-type-badge" :class="typeBadge(item).cls">{{ typeBadge(item).label }}</span>
                            </div>
                            <div class="ri-sub">
                                <span v-if="item.verejny_nazov" class="ri-sub-item">{{ item.verejny_nazov }}</span>
                                <span v-if="item.interny_popis" class="ri-sub-item ri-sub-muted">{{ item.interny_popis }}</span>
                                <span v-if="!item.verejny_nazov && !item.interny_popis" class="ri-sub-item ri-sub-muted">—</span>
                            </div>
                        </div>

                        <!-- Middle: prices -->
                        <div class="ri-prices">
                            <div class="ri-price-block">
                                <span class="ri-price-label">Bez DPH</span>
                                <span class="ri-price-val">{{ fmtPrice(item.cena_bez_dph, item, item.cena_do) }}</span>
                            </div>
                            <div v-if="item.cena_s_dph" class="ri-price-block ri-price-block--dph">
                                <span class="ri-price-label">S DPH</span>
                                <span class="ri-price-val ri-price-val--green">{{ fmtPrice(item.cena_s_dph, item, item.cena_s_dph_do) }}</span>
                            </div>
                        </div>

                        <!-- Right: info + actions -->
                        <div class="ri-actions">
                            <div v-if="hasExtra(item)" class="ri-info">
                                <svg class="ri-info-icon" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                <div class="ri-popover">
                                    <div class="ri-pop-title">Detail výpočtu</div>
                                    <div v-if="item.jednotka" class="ri-pop-row"><span>Jednotka</span><b>{{ item.jednotka }}</b></div>
                                    <div v-if="item.pocet" class="ri-pop-row"><span>Počet</span><b>{{ item.pocet }}<template v-if="item.pocet_do"> – {{ item.pocet_do }}</template></b></div>
                                    <div v-if="item.sadzba" class="ri-pop-row"><span>Sadzba</span><b>{{ item.sadzba }} €</b></div>
                                    <div v-if="item.dph" class="ri-pop-row"><span>Sadzba DPH</span><b>{{ item.dph }} %</b></div>
                                </div>
                            </div>
                            <button class="ri-btn ri-btn--edit" @click="editItem(item)" :title="$t('items.text_5')">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                            </button>
                            <button class="ri-btn ri-btn--del" @click="deleteItem(item)" :title="$t('items.text_6')">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="search_for_items && createEdit == 0"
                class="col-lg-6 mt-4 ml-1"
            >
                <div class="wrapper">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <span>Vyhľadávam položky</span>
                </div>
            </div>
            <div
                v-if="
                    !search_for_items &&
                    data_show.length <= 0 &&
                    createEdit == 0
                "
                class="col-lg-6 mt-4 ml-1"
            >
                <div class="wrapper">
                    <span>Nenašli sa žiadne položky…</span>
                </div>
            </div>
            <div v-if="!searched_items && createEdit == 0" class="btn_showmore">
                <button
                    class="mt-5 zobrazitViac"
                    v-if="
                        load_more_items_btn &&
                        items_count > show_item_offset + show_item_limit
                    "
                    @click="show_more_item"
                >
                    <span v-show="show_item_btn"> Načítať ďalšie položky </span>
                    <div v-show="!show_item_btn" class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </button>
            </div>

            <create-edit-item
                v-if="createEdit != 0"
                :user_id="user_id"
                :status="createEdit"
                :item_edit="item_edit"
                @save="newItem($event)"
                @cancel="createEdit = 0"
            />
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import CreateEditItem from "../items/components/CreateEditItem.vue";
import ToolTip from "../../vue_components/ToolTip.vue";
export default {
    components: { CreateEditItem, ToolTip },
    props: ["user_id", "data", "items_count"],
    data() {
        return {
            createEdit: 0,
            data_without_search: [],
            items: [],
            data_show: [],
            item_edit: null,
            search: null,
            debouncedSearch: null,
            loading: false, // Add this line
            searched_items: false,
            load_more_items_btn: true,
            search_for_items: false,
            show_item_btn: true,
            show_item_offset: 0,
            show_item_limit: 20,
        };
    },
    created() {
        this.items = this.data;
        this.data_without_search = this.data;
        this.data_show = this.data;
    },
    methods: {
        show_more_item() {
            var offset = this.show_item_offset + this.show_item_limit;
            var limit = this.show_item_limit;
            this.show_item_btn = false;
            axios
                .get("/api/items/byCount/" + offset + "/" + limit + "")
                .then((response) => {
                    this.show_item_offset += this.show_item_limit;
                    response.data.forEach((o) => {
                        this.data_without_search.push(o);
                    });
                    this.show_item_btn = true;
                });
        },
        typeBadge(item) {
            switch (item.type_cena) {
                case 0: return { label: 'Hodinová', cls: 'badge--blue' };
                case 1: return { label: 'Rozsah', cls: 'badge--purple' };
                case 2: return { label: 'Vlastná', cls: 'badge--orange' };
                case 4: return { label: 'Hod. rozsah', cls: 'badge--pink' };
                default: return { label: 'Cena', cls: 'badge--green' };
            }
        },
        hasExtra(item) {
            return !!(item.jednotka || item.pocet || item.pocet_do || item.sadzba || item.cena_do || item.cena_s_dph_do || item.dph);
        },
        fmtPrice(price, item, priceDo) {
            if (price === null || price === undefined || price === '') return '';
            let out = parseFloat(price).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
            if (priceDo) {
                out += ' – ' + parseFloat(priceDo).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
            }
            return out;
        },
        setPrice(price) {
            if (price) price = price.toString();
            else return "";
            var len = price ? price.length : 0;
            if (len < 10) return price + " €";
            return price.slice(0, 9) + "... €";
        },
        setSKU(sku, id) {
            var len = sku == null ? 0 : sku.length;
            if (len < 17) return sku;
            return sku.slice(0, 16) + "...";
        },
        setTitle(title) {
            var len = title == null ? 0 : title.length;
            if (len < 18) return title;
            return title.slice(0, 18) + "...";
        },
        createItem() {
            this.createEdit = 1;
            this.item_edit = {
                id: null,
                id_sku: null,
                user_id: null,
                interny_nazov: null,
                verejny_nazov: null,
                interny_popis: null,
                verejny_popis: null,
                cena_bez_dph: null,
                cena_s_dph: null,
                dph: 0,
            };
        },
        editItem(item) {
            this.createEdit = 2;
            this.item_edit = item;
            this.item_edit["dph"] = this.item_edit["dph"] ? parseFloat(this.item_edit["dph"]) : 0;
        },
        deleteItem(item) {
            swal.fire({
                    title: this.$t("items.text_12"),
                    text: this.$t("items.text_13"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    cancelButtonText: this.$t("items.text_14"),
                    confirmButtonText: this.$t("items.text_15"),
                })
                .then((result) => {
                    if (result.value) {
                        axios
                            .post("/api/deleteItem", { id: item.id })
                            .then(() => {
                                this.$toast.success(this.$t("items.text_16"), {
                                    timeout: 2038,
                                });
                                var foundIndex = this.items.findIndex(
                                    (x) => x.id == item.id
                                );
                                this.items.splice(foundIndex, 1);
                            });
                    }
                });
        },
        newItem(item) {
            this.$toast.success(
                this.createEdit == 1
                    ? this.$t("items.text_17")
                    : this.$t("items.text_18"),
                {
                    timeout: 2038,
                }
            );
            var foundIndex = this.items.findIndex((x) => x.id == item.id);
            foundIndex == -1
                ? this.items.push(item)
                : (this.items[foundIndex] = item);
            this.createEdit = 0;
        },
        normalizeString(str) {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        },
        debounceInput: _.debounce(function (e) {
            if (this.search) {
                const encodedSearchValue = encodeURIComponent(this.search);
                axios
                    .get("/api/items/bySearch/" + encodedSearchValue)
                    .then((response) => {
                        this.search_for_items = false;
                        this.data_show = response.data;
                        this.data_show;
                    });
            } else {
                this.load_more_items_btn = true;
                this.search_for_items = false;
                this.data_show = this.data_without_search;
            }
        }, 1000),
        startSearching() {
            if (!this.search) {
                this.load_more_items_btn = true;
                this.search_for_items = false;
                this.data_show = this.data_without_search;
            } else {
                this.search_for_items = true;
                this.load_more_items_btn = false;
                this.data_show = [];
                this.debounceInput();
            }
        },
    },
    watch: {
        search() {
            this.startSearching();
        },
    },
    computed: {
        filteredItems() {
            return this.data_show;
        },
    },
};
</script>

<style lang="scss" scoped>
.btn_showmore {
    width: 1180px;
    max-width: 100%;
    margin: 0 auto;
}

/* ---------- Rich item list ---------- */
.rich-list {
    width: 1180px;
    max-width: 100%;
    margin: 24px auto 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.rich-item {
    display: flex;
    align-items: center;
    gap: 18px;
    background: #ffffff;
    border: 1px solid #EEF1F5;
    border-radius: 11px;
    padding: 15px 18px;
    transition: box-shadow .15s, border-color .15s;

    &:hover {
        border-color: #DDE3E8;
        box-shadow: 0 3px 10px rgba(30, 45, 70, .06);
    }
}

.ri-main {
    flex: 1 1 auto;
    min-width: 0;
}

.ri-title-row {
    display: flex;
    align-items: center;
    gap: 9px;
    min-width: 0;
}

.ri-title {
    font-family: "Montserrat", sans-serif;
    font-weight: 700;
    font-size: 15px;
    line-height: 19px;
    color: #212541;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 340px;
}

.ri-sku {
    flex: none;
    font-family: "Roboto", sans-serif;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .04em;
    color: #8A93A6;
    background: #F3F5F8;
    border-radius: 5px;
    padding: 2px 7px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 130px;
}

.ri-type-badge {
    flex: none;
    font-family: "Roboto", sans-serif;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .04em;
    border-radius: 20px;
    padding: 2px 9px;
    white-space: nowrap;

    &.badge--green  { background: #E6FAF4; color: #0FA37D; }
    &.badge--blue   { background: #E7F0FD; color: #2F7BE0; }
    &.badge--purple { background: #ECEDFD; color: #5B5FE0; }
    &.badge--orange { background: #FEF1E0; color: #C9760F; }
    &.badge--pink   { background: #FDE9EE; color: #D43A63; }
}

.ri-sub {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 3px;
    min-width: 0;
}

.ri-sub-item {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    line-height: 15px;
    color: #5A6473;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 280px;

    &.ri-sub-muted { color: #9CA3AF; }
    & + .ri-sub-item::before {
        content: "·";
        margin-right: 8px;
        color: #C5CBD3;
    }
}

.ri-prices {
    flex: none;
    display: flex;
    align-items: center;
    gap: 26px;
    margin-left: auto;
}

.ri-price-block {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    min-width: 92px;
}

.ri-price-label {
    font-family: "Roboto", sans-serif;
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .07em;
    color: #A6AEBA;
    margin-bottom: 1px;
}

.ri-price-val {
    font-family: "Montserrat", sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: #212541;
    white-space: nowrap;

    &--green { color: #0FA37D; }
}

.ri-actions {
    flex: none;
    display: flex;
    align-items: center;
    gap: 6px;
}

.ri-info {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 2px;

    .ri-info-icon { cursor: help; display: block; }

    &:hover .ri-popover {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
    }
}

.ri-popover {
    position: absolute;
    bottom: calc(100% + 10px);
    right: -8px;
    z-index: 200;
    width: 210px;
    background: #fff;
    border: 1px solid #EAEDF2;
    border-radius: 10px;
    box-shadow: 0 12px 30px rgba(22, 32, 52, .16);
    padding: 11px 13px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(4px);
    transition: opacity .15s, transform .15s, visibility .15s;

    &::after {
        content: "";
        position: absolute;
        top: 100%;
        right: 14px;
        border: 6px solid transparent;
        border-top-color: #fff;
    }
}

.ri-pop-title {
    font-family: "Roboto", sans-serif;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .05em;
    color: #9AA3AE;
    margin-bottom: 7px;
}

.ri-pop-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    color: #5A6473;
    padding: 3px 0;

    b { color: #212541; font-weight: 700; }
    & + .ri-pop-row { border-top: 1px solid #F2F4F7; }
}

.ri-btn {
    width: 30px;
    height: 30px;
    border: 1px solid #EAEDF2;
    border-radius: 8px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background .15s, border-color .15s, color .15s;

    &--edit { color: #6B7280; &:hover { background: #F4F7FB; border-color: #DDE3E8; color: #2B3240; } }
    &--del  { color: #F93C34; &:hover { background: #FDECEC; border-color: #F7C9C7; } }
}

@media only screen and (max-width: 700px) {
    .rich-item { flex-wrap: wrap; gap: 10px; }
    .ri-prices { margin-left: 0; gap: 16px; }
    .ri-title { max-width: 200px; }
}
.vue_tooltip .hide {
    display: none;
}
.vue_tooltip .show {
    display: block;
}
.vue_show_tooltip {
    position: relative;
}
.box {
    width: 900px;
    background: #ffffff;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 15px 15px;
    margin: 0px auto 9px auto;
    .sku {
        width: 140px;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        color: #212541;
    }
    .i_nazov,
    .v_nazov {
        display: grid;
        width: 220px;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #212541;
        span {
            font-family: "Roboto";
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 14px;
            color: #9ca3af;
        }
    }
    .cena_b_dph,
    .cena_s_dph {
        width: 140px;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: #212541;
    }
    .actions {
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        svg {
            cursor: pointer;
        }
    }
}
.box.titles {
    width: 900px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    margin: 0px auto 6px auto;
    background: transparent;
    margin-top: 36px;
    padding: 0;
    padding-left: 15px;
    .sku {
        width: 140px;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: #212541;
        opacity: 0.4;
    }
    .i_nazov,
    .v_nazov {
        width: 208px;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #212541;
        opacity: 0.4;
    }
    .cena_b_dph,
    .cena_s_dph {
        width: 140px;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: #212541;
        opacity: 0.4;
    }
    .actions {
        width: 40px;
    }
}
.cont {
    width: 1180px;
    margin: 0 auto;
    padding: 35px 0;
    @media only screen and (max-width: 1500px) {
        width: 95%;
    }
    h1 {
        @media only screen and (max-width: 600px) {
            width: 90%;
            margin: 0 auto;
        }
        font-family: "Roboto";
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        color: #000000;
    }
    h3 {
        width: 700px;
        @media only screen and (max-width: 600px) {
            width: 90%;
        }
        margin: 10px auto 27px auto;
        font-family: "Roboto";
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 150%;
        text-align: center;
        color: #9598a7;
    }
    .create_item {
        width: 230px;
        height: 55px;
        @media only screen and (max-width: 600px) {
            margin-top: 25px;
            width: 300px;
        }
        background: #2ed8b6;
        border-radius: 4px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #ffffff;
        cursor: pointer;
        transition: 0.5s all;
        &:hover {
            background: #23caa9;
            color: #ffffff;
        }
        &.disabled {
            cursor: no-drop;
            pointer-events: none;
            opacity: 0.3;
        }
    }
}
.search_create_btns {
    width: 1180px;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
}
.filter1 {
    padding-bottom: 0;
    @media only screen and (max-width: 600px) {
        display: grid;
    }
    .filter_svg {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        right: 15px;
        cursor: pointer;
    }
    .filter_svg2 {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        right: 15px;
        cursor: pointer;
    }
    .filter_input {
        width: 300px;
        height: 55px;
        background: #ffffff;
        border: 1px solid #dde3e8;
        box-sizing: border-box;

        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;

        color: #9598a7;

        padding: 15px;
    }
    .d-inline h5 {
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: #212541;
    }
    .combobox_mojefirmy_search {
        margin-left: 30px;
        position: relative;
        .v-menu__content {
            left: 0 !important;
        }
        .v-input {
            width: 300px;
            height: 55px;
        }
        .theme--light.v-text-field--filled
            > .v-input__control
            > .v-input__slot {
            background: #fff;
        }
        input {
            font-family: Roboto !important;
            font-style: normal !important;
            font-weight: bold !important;
            font-size: 14px !important;
            line-height: 16px !important;
            color: #212541 !important;
        }
        .v-input__slot,
        .theme--light.v-text-field--filled
            > .v-input__control
            > .v-input__slot {
            background: #fff !important;
            border: 1px solid #dde3e8 !important;
            border-radius: 0 !important;
            input {
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;
                color: #212541 !important;
            }
        }

        .v-text-field > .v-input__control > .v-input__slot {
            &:after {
                content: none !important;
            }
            &:before {
                content: none !important;
            }
        }
        .v-label.v-label--active.theme--light {
            left: -11px !important;
            top: 14px !important;
            font-family: Roboto !important;
            font-style: normal !important;
            font-weight: bold !important;
            font-size: 11px !important;
            line-height: 13px !important;
            letter-spacing: 0.1em !important;
            text-transform: uppercase !important;
            color: #9598a7 !important;
            margin-top: 0 !important;
        }
        .v-label.theme--light {
            top: 22px !important;
            font-family: Roboto !important;
            font-style: normal !important;
            font-weight: bold !important;
            font-size: 11px !important;
            line-height: 13px !important;
            letter-spacing: 0.1em !important;
            text-transform: uppercase !important;
            color: #9598a7 !important;
            margin-top: 0 !important;
        }
    }
}
@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.rotating {
    animation: rotate 0.5s linear infinite; /* 2s duration, adjust as needed */
}
</style>
